export default __webpack_public_path__ + "static/media/logout.83b2ca47.svg";